import type { TTreatmentValues } from '../../react-query/useInsightsRecap';

export const defaultHighlightedTreatment = {
  treatmentType: 'CROWNS' as 'SRP' | 'CROWNS' | 'FILLINGS',
  treatmentPercentChange: 0,
  recapPeriodValuePerPatient: 0,
};

export const calculateHighlightedTreatment = (
  treatmentData: TTreatmentValues,
) => {
  if (!treatmentData || !treatmentData.preAi || !treatmentData.recapPeriod) {
    return defaultHighlightedTreatment;
  }

  const { preAi, recapPeriod } = treatmentData;

  return recapPeriod.reduce((currentBestTreatment, recapPeriodTreatment) => {
    const recapPeriodValuePerPatient =
      recapPeriodTreatment.totalValuePerPatient;
    const preAiValuePerPatient = preAi.find(
      (value) => value.treatmentType === recapPeriodTreatment.treatmentType,
    )?.totalValuePerPatient;

    const canCalculatePercentage =
      recapPeriodValuePerPatient && preAiValuePerPatient;
    const treatmentPercentChange = canCalculatePercentage
      ? (100 * (recapPeriodValuePerPatient - preAiValuePerPatient)) /
        preAiValuePerPatient
      : 0;

    const hasValueIncreasedWithAI =
      treatmentPercentChange > currentBestTreatment.treatmentPercentChange;

    return hasValueIncreasedWithAI
      ? {
          treatmentType: recapPeriodTreatment.treatmentType,
          treatmentPercentChange: treatmentPercentChange,
          recapPeriodValuePerPatient: recapPeriodTreatment.totalValuePerPatient,
        }
      : currentBestTreatment;
  }, defaultHighlightedTreatment);
};
